import { useBannerInteractionState } from '@ecomm/promotions-hooks'
import { AIChatNav } from '@ecomm/shared-icons'
import { ALBY_CHAT_BOT_ID } from './constants'
import { onClick } from './useAIChatButtonActions'

type AIChatNavButtonProps = {
  readonly classes: string
}

export function AIChatNavButton({ classes }: AIChatNavButtonProps) {
  // Check if the bottom mobile banner has expanded
  const { isVisible, onCloseBanner } = useBannerInteractionState()

  return (
    <button
      className={`bg-transparent relative border-0 border-b border-solid hover:border-bottom-primary-100 duration-300 min-[1126px]:h-auto min-[1126px]:text-white cursor-pointer text-white no-underline ${classes}`}
      aria-controls="chat-window"
      aria-label="Chat with our AI assistant"
      onClick={onClick(isVisible, onCloseBanner, ALBY_CHAT_BOT_ID)}
    >
      <AIChatNav className="h-6 w-6" />
      <div className="mt-0 flex min-[1126px]:mt-1">
        <span>Ask AI</span>
      </div>
    </button>
  )
}
